import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import { deletestaff, groupliststaff, liststaff } from "../../../services/admin";
import ImageUrl from "../../../ImageUrl";
import moment from "moment/moment";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { Modal } from "react-bootstrap";

export default function Allstaff() {
    const [filterProduct, setFilterProduct] = useState([]);
    const [ppath, setPPath] = useState("");
    const navigate = useNavigate();

    const columnDefs = [
        {
            headerName: "Actions",
            field: "id",
            width: 140,
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        {localStorage.getItem("Role") == 1 &&
                            <>
                                <a onClick={() => navigate(`/staff/staffdetail/${params.value}`)}
                                    className="btn-sm btn-info me-2"
                                    title="Staff Detail"
                                >
                                    <i className="fa fa-edit"></i>
                                </a>
                                <a onClick={() => handleSwitch(params.value)}
                                    className="btn-sm btn-danger me-2"
                                    title="Delete Staff"
                                >
                                    <i className="fa fa-trash"></i>
                                </a>
                            </>
                        }

                        <a onClick={() => handleShow(params.value)}
                            className="btn-sm btn-warning me-2"
                            title="Group List"
                        >
                            <i className="fa fa-list"></i>
                        </a>
                    </div>
                );
            },
        },
        {
            headerName: "Photo",
            field: "photo",
            width: 100,
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                if (params.value !== null) {
                    return (
                        <div className="text-center">
                            <img src={ppath + params.value} style={{ width: "50px", height: "50px", borderRadius: "50%" }} />
                        </div>
                    );
                }
            },
        },
        {
            headerName: "Staff Name",
            field: "staff_name",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Staff Code",
            field: "staff_code",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "DOB",
            field: "date_of_birth",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                if (params.value !== null) {
                    return (
                        moment(params.value).format("DD-MM-YYYY")
                    );
                }
            }
        },
        {
            headerName: "Gender",
            field: "gender",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Type",
            field: "role_name",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Email",
            field: "email",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Mobile",
            field: "phone",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Address",
            field: "address",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
        }
    ];

    useEffect(() => {
        funlist();

    }, []);

    function funlist() {
        setFilterProduct([]);
        setPPath("");
        liststaff(localStorage.getItem("branch")).then((res) => {
            if (res.status === true) {
                setFilterProduct(res.data.details);
                setPPath(ImageUrl + res.data.path);
            }
        });
    }

    function handleSwitch(lid) {
        Swal.fire({
            text: "Are you sure want to Delete?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#ac0404",
            cancelButtonColor: "#6259ca",
            confirmButtonText: "Delete",
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {

                deletestaff(lid).then((response) => {
                    if (response.status === true) {
                        funlist();
                    }
                });
            }
        });

    }
    const [show, setShow] = useState(false);
    const [slist, setSList] = useState([]);
    function handleShow(lid) {
        setShow(true);
        groupliststaff(lid).then((response) => {
            if (response.status === true) {
                setSList(response.data);
            }
        })
    }
    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">All Staff</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Staff</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        All Staff
                    </li>
                </ol>

            </div>


            <div className="content-body">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-header">
                                <h2 className="main-content-title tx-24 mg-b-5">
                                    All Staff Detail
                                </h2>
                            </div>
                            <div className="card-body">
                                <div className="ag-theme-alpine ag-style mt-2">
                                    <AgGridReact
                                        columnDefs={columnDefs}
                                        rowData={filterProduct}
                                        pagination="true"
                                        paginationPageSize="10"
                                        sortingOrder={["asc", "desc"]}
                                        suppressDragLeaveHidesColumns={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={show} onHide={() => setShow(false)}>
                <Modal.Header>
                    <h4>Group List</h4>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <table className="responsive-table">
                            <thead>
                                <tr>
                                    <th>SI No</th>
                                    <th>Group Name</th>
                                </tr>
                            </thead>

                            <tbody>
                                {slist.map((entry, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{entry.group_name}</td>
                                    </tr>
                                ))}
                                {slist.length === 0 && <tr><td colSpan={2}>No Group Found</td></tr>}

                            </tbody>
                        </table>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <a className='btn btn-info' onClick={() => setShow(false)}>Close</a>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
